import { createMachine, assign, DoneInvokeEvent } from 'xstate';

import { setCatalogExpandState } from './actions';
import { Context, Events, ProductFamily } from './types';

const productCatalog = createMachine<Context, Events>(
  {
    id: 'productCatalog',
    predictableActionArguments: true,
    initial: 'idle',
    context: {
      items: [],
      expandedCatalogItems: [],
    },
    states: {
      idle: {
        on: {
          INITIALIZE: {
            target: 'loading',
          },
        },
      },
      loading: {
        invoke: {
          id: 'productCatalogFetch',
          src: 'getProductsCatalog',
          onDone: {
            target: 'ready',
            actions: [
              assign(
                (_ctx, event: DoneInvokeEvent<{ items: ProductFamily[] }>) => ({
                  items: event.data.items,
                  expandedCatalogItems: event.data.items.map(({ id }) => id),
                })
              ),
            ],
          },
          onError: {
            target: 'error',
          },
        },
      },
      error: {
        on: {
          RETRY_FETCH_PRODUCT_CATALOG: {
            target: 'loading',
          },
        },
      },
      ready: {
        on: {
          SET_CATALOG_EXPAND: {
            actions: 'setCatalogExpandState',
          },
        },
      },
    },
  },
  {
    actions: {
      setCatalogExpandState,
    },
  }
);

export { productCatalog };
